<div class='vtr-ui-days-picker'>
	<div class="row">
		<p class="sub-heading"
			id="{{linkId}}"
			role="text">
			{{ subHeadingText | translate | uppercase }}</p>
	</div>
	<div class="row">
		<div class="col-md-12 col-sm-12 pl-0">
			<div class="dropdown">
				<label for="{{daysId}}"
					id="smartStandby-shedule"
					#combo
					role="combobox"
					attr.aria-label="{{ subHeadingText | translate}}, {{ smartStandbyService.scheduleLongForm}}"
					[attr.aria-expanded]="showDropDown"
					tabindex="0"
					(click)="onToggleDropDown()"
					(keydown.enter)="onToggleDropDown()"
					class="dropbtn dropbtn-{{showDropDown}}"
					#dayslistbox
					[ngClass]="{ 'label-text': showDropDown }">
					<div class="row align-items-center d-flex justify-content-between pl-5">
						<h5 id="smartStandby-schedule"
							attr.aria-label="smartStandby-schedule"
							class="smartStandby-schedule-selected-title"
							>{{smartStandbyService.schedule}}</h5>
						<div class="toggle-icon"
							id="smartStandby-days-picker-dropDown">
							<fa-icon *ngIf="!showDropDown"
								[icon]="['fal', 'chevron-down']"
								role="img"
								alt="Arrow Down"
								aria-label="Arrow Down"></fa-icon>
							<fa-icon *ngIf="showDropDown"
								[icon]="['fal', 'chevron-up']"
								role="img"
								alt="Arrow Up"
								aria-label="Arrow Up"></fa-icon>
						</div>
					</div>
				</label>

				<div class="weekdays-block "
					*ngIf="showDropDown">
					<section class="dropdown-content">
						<div class="row">
							<div class="col">
								<div class="main-block"
									id="radio-group"
									role="radiogroup"
									aria-label="days list, select using arrow keys"
									(keydown)="navigateByKeys($event, -1)"
									tabindex="0">
									<div *ngFor="let i of smartStandbyService.allDays; let idx = index;"
										id="{{'day' + idx}}"
										(keydown)="navigateByKeys($event, idx)">
										<div class="custom-control custom-checkbox">
											<vtr-material-checkbox
												componentId="{{ 'device.deviceSettings.power.smartStandby.days.name.' + i.shortName | translate}}"
												[value]="i.status"
												[checked]="i.status"
												(toggle)="selectDay($event, i.shortName)"
												[label]="'device.deviceSettings.power.smartStandby.days.name.' + i.shortName | translate">
											</vtr-material-checkbox>
										</div>
									</div>
								</div>
								<div class="d-flex justify-content-end py-3">
									<p class="select-close"
										*ngIf="!smartStandbyService.checkedLength"
										id="smartStandby-warningtip"
										attr.aria-label="{{'device.deviceSettings.power.smartStandby.warningtip' | translate}}"
										tabindex="0">
										{{ 'device.deviceSettings.power.smartStandby.warningtip' | translate }}</p>
									<div class="banner-middle">

									</div>
									<div class="select-close">
										<fa-icon [icon]="['fal', 'check']"
											(click)="setOffDays(dayslistbox)"
											(keydown.enter)="[setOffDays(dayslistbox),combo.focus()]"
											role="button"
											tabindex="0"
											id="daysPickerDone"
											attr.aria-label="daysPickerDone"
											*ngIf="smartStandbyService.checkedLength > 0"
											attr.aria-label="{{ 'systemUpdates.popup.okayButton' | translate}}">
										</fa-icon>
										<fa-icon [icon]="['fal', 'times']"
											id="daysPickerClear"
											role="button"
											tabindex="0"
											attr.aria-label="daysPickerClear"
											(click)="clearSettings(dayslistbox)"
											(keydown.enter)="[clearSettings(dayslistbox),combo.focus()]"
											attr.aria-label="{{ 'systemUpdates.popup.cancelButton' | translate}}">
										</fa-icon>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</div>